import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 36 36"
  >
    <g fill={colorValue} clipPath="url(#clip0_4397_9862)">
      <path
        fillRule="evenodd"
        d="M24.806 16.467a4.594 4.594 0 1 1-4.443-8.04 6.748 6.748 0 0 0-9.113 6.323v.75a8.22 8.22 0 0 1-2.119 5.52.75.75 0 0 0 .298 1.205c1.564.577 3.183.994 4.831 1.244a3.75 3.75 0 1 0 7.48 0 24.6 24.6 0 0 0 4.831-1.243.75.75 0 0 0 .297-1.206 8.2 8.2 0 0 1-2.062-4.553m-8.91 8.073a2.25 2.25 0 0 1-.144-.89c1.496.135 3 .135 4.496 0a2.25 2.25 0 0 1-4.353.89"
        clipRule="evenodd"
      ></path>
      <path d="m22.38 14.543 3-3a.751.751 0 0 0-1.06-1.061l-2.47 2.47-.97-.97a.752.752 0 0 0-1.223.243.75.75 0 0 0 .162.818l1.5 1.5a.75.75 0 0 0 1.062 0"></path>
    </g>
    <defs>
      <clipPath id="clip0_4397_9862">
        <rect width="24" height="24" x="6" y="6" fill="#fff" rx="5"></rect>
      </clipPath>
    </defs>
  </svg>
  );
};